export default __webpack_public_path__ + "static/media/Murali Srinivasan.4aab72a9.jpg";